import crawlApi, { type CrawlRequestBody } from './crawlApi';

type JobPage = string | number | null | undefined;
type ChecklistCountArgs = { job_page: JobPage; domain_slug: string };

const checklistApi = crawlApi.injectEndpoints({
  endpoints: build => ({
    getInfo: build.mutation<unknown, CrawlRequestBody>({
      query: (body: CrawlRequestBody) => ({
        url: `/khazesh/v3/checklist/get_info`,
        method: 'POST',
        body: body
      }),
      invalidatesTags: ['CHECKLIST']
    }),
    countCrawlChecklist: build.query<unknown, ChecklistCountArgs>({
      query: ({ job_page, domain_slug }: ChecklistCountArgs) => ({
        url: `/khazesh/v3/checklist/get_num_of_checklist_categories`,
        params: { job_page, domain_slug }
      })
    }),
    getSimilarTitlesByGroupId: build.mutation<unknown, CrawlRequestBody>({
      query: (body: CrawlRequestBody) => ({
        url: `/khazesh/v3/similar_title/by_group_id`,
        method: 'POST',
        body: body
      })
    }),
    getSimilarParagraphsByGroupId: build.mutation<unknown, CrawlRequestBody>({
      query: (body: CrawlRequestBody) => ({
        url: `/khazesh/v3/similar_paragraph/by_group_id`,
        method: 'POST',
        body: body
      })
    })
  })
});

export const {
  useGetInfoMutation,
  useCountCrawlChecklistQuery,
  useGetSimilarParagraphsByGroupIdMutation,
  useGetSimilarTitlesByGroupIdMutation
} = checklistApi;
export default checklistApi;
